<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-base-evgOsWhGoods',
  components: { PageTable },
}
</script>
